import { useQuery } from "@tanstack/react-query";
import type { TApiODIN } from "@/apis/odin/apiODIN";
import type { TDashboardFilter } from "@/ui/organisms/dashboardTypes";
import { analyticsKeys } from "@/queries/queryKeys";

export const createAnalyticsQueryHooks = ({
    apiODIN,
}: {
    apiODIN: TApiODIN;
}) => {
    const useDashboardAnalyticsQuery = (
        filter: TDashboardFilter,
        options?: { enabled?: boolean },
    ) =>
        useQuery({
            queryKey: analyticsKeys.dashboard(filter),
            queryFn: async () => {
                const response = await apiODIN.getDashboardAnalytics(filter);
                return response.data;
            },
            enabled: options?.enabled,
        });

    return {
        useDashboardAnalyticsQuery,
    };
};

export type TAnalyticsQueryHooks = ReturnType<typeof createAnalyticsQueryHooks>;
